import BaseComponent from 'scripts/BaseComponent.js';
import Cart from '../cart';

export default class CartUpsell extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      optionToggleBtn: '.js-optionToggleBtn',
      optionSelectContainer: '.js-optionSelectContainer',
      optionBtn: '.js-optionBtn',
      addUpsellBtn: '.js-addUpsellBtn',
      selectedValue: '.js-selectedValue',
      upsellPrice: '.js-upsellPrice',
      variantImageSources: '.js-variantImageWrap source',
      variantImage: '.js-variantImage',
    };

    this.dom = {
      $component: component,
      $optionToggleBtn: this.$get(this.refs.optionToggleBtn),
      $optionSelectContainer: this.$get(this.refs.optionSelectContainer),
      $optionBtns: this.$getAll(this.refs.optionBtn),
      $addUpsellBtn: this.$get(this.refs.addUpsellBtn),
      $selectedValue: this.$get(this.refs.selectedValue),
      $upsellPrice: this.$get(this.refs.upsellPrice),
      $variantImageSources: this.$getAll(this.refs.variantImageSources),
      $variantImage: this.$get(this.refs.variantImage),
    };

    this.state = {
      optionsOpen: false,
      optionsOpenClass: 'open-options',
      activeOptionClass: 'active-option',
    };

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();

    this.setClick(dom.$optionToggleBtn, this.toggleOptions);
    this.setClickWithElement(dom.$optionBtns, this.optionSelect);
    this.setClickWithElement(dom.$addUpsellBtn, this.addUpsellProduct);
  }

  toggleOptions() {
    const { state } = this;

    if (state.optionsOpen) {
      this.closeOptions();
    } else {
      this.openOptions();
    }
  }

  openOptions() {
    const { dom, state } = this;

    dom.$component.classList.add(state.optionsOpenClass);
    document.addEventListener('click', this.clickOutHandler.bind(this));
    state.optionsOpen = true;
  }

  closeOptions() {
    const { dom, state } = this;

    dom.$component.classList.remove(state.optionsOpenClass);
    document.removeEventListener('click', this.clickOutHandler.bind(this));
    state.optionsOpen = false;
  }

  clickOutHandler(e) {
    const { dom } = this;

    if (!dom.$optionSelectContainer.contains(e.target)) {
      this.closeOptions();
    }
  }

  optionSelect(btn) {
    const { dom, state } = this;
    const {
      variantId,
      variantTitle,
      variantPrice,
      variantImage,
    } = btn.dataset;

    dom.$optionBtns.forEach((elem) => elem.classList.remove(state.activeOptionClass));
    btn.classList.add(state.activeOptionClass);

    dom.$selectedValue.textContent = variantTitle;
    dom.$upsellPrice.textContent = variantPrice;
    dom.$addUpsellBtn.setAttribute('data-variant-id', variantId);
    dom.$variantImage.setAttribute('src', variantImage);
    dom.$variantImageSources.forEach((source) => source.setAttribute('srcset', variantImage));
    this.closeOptions();
  }

  addUpsellProduct(btn) {
    const {
      variantId,
      itemKey,
      itemTitle,
      itemSku,
      upsellId,
    } = btn.dataset;

    const properties = {
      Arrangement: itemTitle,
      _associated_product_key: itemKey,
      _associated_product_sku: itemSku,
      _upsell_id: upsellId,
    };
    Cart.addItem(variantId, properties, 1, false);
  }
}
